/**
 * Created by pandemio on 11/8/18.
 */
import React from 'react';
import Select from 'react-select';
import ApiCalls from '../../custom-classes/api-calls';
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the selection of products
 */
class SelectorState extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state = {
            options: [], // The options to fill the selection
            value: this.props.data.stateRegion,
            countryIsoCode: this.props.data.country,
            mounted: false,
            stateRequired: this.props.data.stateRequired,
            disabled: this.props.disabled
        };
    }

    /**
     * Component will receive props. To receive the country ISOs
     * @param nextProps
     */
    componentWillReceiveProps(props) {

        this.setState({
            disabled: props.disabled,
            value:  props.value
        });

        if (this.state.mounted
            && this.state.countryIsoCode !== null
            && this.state.countryIsoCode !== props.data.country
        ) {
            this.setState({countryIsoCode: props.data.country},
                ()=> {
                    this.callData();
                });
        }
    }

    componentDidMount() {
        this.setState({
            mounted: true
        });
    }

    /**
     * Call the data API
     */
    callData() {

        if (this.state.countryIsoCode !== "0") {
            // This is promise
            let apiCall = ApiCalls.getStateProvinces(this.state.countryIsoCode);
            let arrOptions = [];
            let dataReturned;

            // After the api call, fill the data
            apiCall.then((data)=> {
                dataReturned = data.StatesRegionsProvidences;
                // Now fill the selections
                for (let i = 0; i < dataReturned.length; i++) {
                    arrOptions.push({value: dataReturned[i].IsoCode, label: dataReturned[i].Name });
                }
            }).then(() => {
                if (this.state.mounted) {
                    this.setState({
                        options: arrOptions
                    });
                }
            });
        }
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     * @param event The event (on change)
     */
    handleChange = (object) => {
        this.setState({value: object.value}, ()=> {
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render() {
        return (
            <div>
                {
                    this.state.options.length > 1 ?
                        <Select
                            value={this.state.options.find(option => option.value === this.state.value)}
                            isDisabled={this.state.disabled} options={this.state.options} name="states"
                                onChange={this.handleChange} placeholder=
                            {
                                <Translate id="register.select-state" options={{renderInnerHtml: false}}/>
                            }
                        /> : null
                }
            </div>
        )
    }
}

export default SelectorState;